import React,{useContext, useEffect, useState} from "react";
import { Checkbox, DefaultButton, Dropdown, Icon, PrimaryButton, Stack, TooltipHost } from "@fluentui/react";
import themeContext from "../../context/theme/ThemeContext";
import { USERTYPES } from "../../constants/Constants";
import studylistContext from "../../context/studylist/StudylistContext";
import studyReportContext from "../../context/studyreport/StudyReportContext";
import { t } from "i18next";
import CustomDefaultButton from "../../pages/StudyList/components/CustomButton/CustomDefaultButton";
import CustomToolTipHost from "../CustomToolTipHost/CustomToolTipHost";
import BrowserCheck from "../../pages/StudyList/components/BrowserCheck";
import { getEnv } from '../../helpers/EnvHelper';

const TablePaginationv2 = (props) => {

  const {theme, themeName, setThemeName, setTheme} = useContext(themeContext);
  const {searchResultLength,searchResultLengthObj, totalRecordCount,activeTab, setResetRowSelection} = useContext(studylistContext);
  const { alertSuccessModal, setAlertSuccessModal } = useContext(studyReportContext);

  const currTotalRecordCount = totalRecordCount[props.totalCountKey || activeTab] || 0;
  const start = currTotalRecordCount == 0 ? 0 : (props.pagination.pageIndex) * props.pagination.pageSize + 1;
  const end = Math.min((props.pagination.pageIndex+1) * props.pagination.pageSize, currTotalRecordCount);

  const browserCheck = props.browserCheck === undefined ? false : props.browserCheck;

  useEffect(()=>{
      if(!alertSuccessModal.show && props.pageIndex > 0 && searchResultLength <= 0){
        // console.log("---- Use Effect Running ----",searchResultLength,props.pageIndex);
        let tempPaginationObj = {
          pageIndex : props.pagination.pageIndex - 1,
          pageSize : props.pagination.pageSize
        };
        
        props.setPagination(tempPaginationObj)

        setAlertSuccessModal(()=>{
          const newItem = {...alertSuccessModal};
          newItem.show = true;
          newItem.heading = "Alert";
          newItem.isError = false;
          newItem.isSuccess = false;
          newItem.isWarning = true;
          newItem.description = t("string-literals.no-more-pages");
          return newItem;
        });
      }
  },[searchResultLength])

  const isVdcPlatform = getEnv("REACT_APP_VDC_PLATFORM") === "true" || getEnv("REACT_APP_VDC_PLATFORM") === true;

  const paginationSize =  [
    {
      key: 10,
      text: 10,
    },
    {
      key: 25,
      text: 25,
    },

    {
      key: 50,
      text: 50,
    },
    {
      key: 100,
      text: 100,
    },
    ...(isVdcPlatform ? [] : [{ key: 200, text: 200 }])
  ];

  const handlePageSizeChange = (value) => {
    let tempPaginationObj = {
      pageIndex : 0,
      pageSize : value
    }
    
    props.setPagination(tempPaginationObj)
    setResetRowSelection(true);
  }


    return (
      !props.showCount ?
        <div
          className="pagination-list-view"
          style={{
            flexDirection: "row",
            justifyContent: "flex-start",
            marginBottom: "0px",
          }}
        >
          {props.showPageSize && <Dropdown
        selectedKey={props.pageSize}
        options={paginationSize}
        style={{marginRight:"10px"}}
        onChange={(e,value) => handlePageSizeChange(value.key)}
      />}
          <div className="pagination-pageCount-study-list">
            <div
              className="left-right-icon-pagination"
              style={{
                cursor: !props.table.getCanPreviousPage() ? "not-allowed" : "pointer",
                opacity: !props.table.getCanPreviousPage() ? "0.5" : "1",
              }}
              onClick={() => props.table.previousPage()}
            >
              <Icon
                iconName="ChevronLeft"
                className={`pagination-pageCountElement-study-list ${
                  !props.table.getCanPreviousPage()
                    ? "pagination-disabled-study-list"
                    : ""
                }`}
                
              ></Icon>
            </div>

            {props.arrayPageIndex.map((page, index) => {
              return (
                <DefaultButton
                  key={index}
                  className={`pagination-button-study-list pagination-pageCountElement-study-list ${
                    props.table.getState().pagination.pageIndex + 1 === page
                      ? "pagination-selected-study-list"
                      : ""
                  }`}
                  style={{
                    border: "none",
                    height: "28px",
                    pointerEvents: page == "......" ? "none" : "unset",
                    cursor: page == "......" ? "not-allowed" : "pointer",
                  }}
                  text={page == "......" ? "......" : page.toString()}
                  onClick={() => {props.table.setPageIndex(page-1)}}
                />
              );
            })}
            {props.arrayPageIndex.length==0 && 
                <DefaultButton
                  className={`pagination-button-study-list pagination-pageCountElement-study-list ${
                     "pagination-selected-study-list"
                  }`}
                  style={{
                    border: "none",
                    height: "28px",
                    pointerEvents: "none",
                    cursor: "pointer",
                  }}
                  text={"1"}
                  //onClick={() => table.setPageIndex(page-1)}
                />
                }
            {/* <div>
              <p
                className={`pagination-pageCountElement ${
                  !table.getCanNextPage() ? "pagination-disabled" : ""
                }`}
                onClick={() => table.setPageIndex(table.getPageCount() - 1)}
              >
                &nbsp;&nbsp; {t("statements.last")}
              </p>
            </div> */}
            <div
              className="left-right-icon-pagination"
              style={{
                cursor: !props.table.getCanNextPage() ? "not-allowed" : "pointer",
                opacity: !props.table.getCanNextPage() ? "0.5" : "1",
              }}
              onClick={() => props.table.nextPage()}
            >
              <Icon
                iconName="ChevronRight"
                className={`pagination-pageCountElement-study-list ${
                  !props.table.getCanNextPage()
                    ? "pagination-disabled-study-list"
                    : ""
                }`}
               
              ></Icon>
            </div>
          </div>
          {/* <PrimaryButton 
            text={!props.showCount?"Hide Pagination":"Show Pagination"}
            onClick={()=>{props.setShowCount((prev)=>!prev)}}
        /> */}

        {(props.roles[0] == USERTYPES.FIRMADMIN || props.roles[0] == USERTYPES.RADIOLOGIST || ( props.roles[0] == USERTYPES.SUPERVISOR  && getEnv("REACT_APP_VDC_PLATFORM") == "true")) &&

          // <CustomDefaultButton onClick={()=>{props.setShowCount((prev)=>!prev)}}
          // text={!props.showCount?t("button.hide-pagination"):t("button.show-pagination")}
          //  />
          //  <PrimaryButton
          //  onClick={()=>{props.setShowCount((prev)=>!prev)}}
          // text={!props.showCount?t("button.hide-pagination"):t("button.show-pagination")} />
          <div className="studylist-underline-button" onClick={()=>{props.setShowCount((prev)=>!prev)}}>
            {!props.showCount?t("button.hide-pagination"):t("button.show-pagination")}
          </div>
        
        // <PrimaryButton 
        //             text={!props.showCount?"Hide Pagination":"Show Pagination"}
        //             onClick={()=>{props.setShowCount((prev)=>!prev)}}
        //             style={{
        //               fontSize: "12px",
        //               fontWeight: "400",
        //               padding: "0px 3px",
        //               height: "30px",
        //               background: themeName =="dark" || themeName =="dark-midnight"?"#0b1a28":"#80808000",
        //               border: themeName =="dark" || themeName =="dark-midnight"?"none":"1px solid black",
        //               color:themeName =="dark" || themeName =="dark-midnight"?"white":"black",
        //               borderRadius: "5px",
        //               marginLeft: "10px",
                      
        //             }}
        //         />
          }
          {!props.showCount && (props.roles[0] == USERTYPES.FIRMADMIN || props.roles[0] == USERTYPES.RADIOLOGIST || props.roles[0] == USERTYPES.SUPERVISOR) && getEnv("REACT_APP_VDC_PLATFORM") =="true" && (<div style={{ "marginLeft": "10px"}}>Displaying {start}-{end} of {currTotalRecordCount}</div>)}

          {!props.showCount && (props.roles[0] == USERTYPES.FIRMADMIN || props.roles[0] == USERTYPES.RADIOLOGIST) && getEnv("REACT_APP_VDC_PLATFORM") === "false" && (<div style={{ "marginLeft": "10px"}}>Displaying {start}-{end} of {currTotalRecordCount}</div>)}
          {/* <BrowserCheck /> */}
        </div>: 



        <div
        className="pagination-list-view"
        style={{
          flexDirection: "row",
          // justifyContent: "space-between",
          marginBottom: "1px",
        }}
      >
       {props.showPageSize && <Dropdown
        selectedKey={props.pageSize}
        options={paginationSize}
        style={{marginRight:"10px"}}
        onChange={(e,value) => handlePageSizeChange(value.key)}
      />}
        <div className="pagination-pageCount-study-list">

        <div
            className="left-right-icon-pagination-first-block"
            style={{
              cursor: props.pageIndex == 0 ? "not-allowed" : "pointer",
              opacity: props.pageIndex == 0 ? "0.5" : "1",
            }}
            onClick={() => {
              console.log(props.pageIndex);
              let tempPaginationObj = {
                pageIndex : 0,
                pageSize : props.pagination.pageSize
              }
              
              props.setPagination(tempPaginationObj)}}
          >
            <CustomToolTipHost content="First Page">
            {/* <div className="studylist-pagination-first-button">
                <span className="studylist-pagination-goto-text">Go to start</span>
            </div> */}

            {/* <CustomDefaultButton style={{cursor: props.pageIndex == 0 ? "not-allowed" : "pointer"}} onClick={()=>{}} 
              text={t("button.go-to-start")}
              /> */}
        <PrimaryButton
           onClick={()=>{}} 
           text={t("button.go-to-start")} 
           style={{cursor: props.pageIndex == 0 ? "not-allowed" : "pointer"}}
           />
            
            </CustomToolTipHost>
          </div>

          <div
            className="left-right-icon-pagination"
            style={{
              cursor: props.pageIndex == 0 ? "not-allowed" : "pointer",
              opacity: props.pageIndex == 0 ? "0.5" : "1",
              background: themeName!="light"?"":"white"
            }}
            onClick={() => {
              let tempPaginationObj = {
                pageIndex : props.pagination.pageIndex > 1?props.pagination.pageIndex - 1: 0,
                pageSize : props.pagination.pageSize
              }
              
              props.setPagination(tempPaginationObj)}}
          >
            <Icon
              iconName="ChevronLeft"
              className={`pagination-pageCountElement-study-list pagination-disabled-study-list ${
                props.pageIndex == 0
                  ? "pagination-disabled-study-list"
                  : ""
              }`}
              style={{color: themeName != "light" ?'white':'black'}}
              
            ></Icon>
          </div>

          {props?.pageIndex != null && <DefaultButton
                  className={`pagination-button-study-list pagination-pageCountElement-study-list pagination-selected-study-list`}
                  style={{
                    border: "none",
                    height: "28px",
                    pointerEvents: "none",
                    cursor: "default"
                  }}
                  text={props.pageIndex+1}
                  onClick={() => {}}
                />}
          
          
          <div
            className="left-right-icon-pagination"
            style={{
              cursor: "pointer",
              opacity: "1",
              background: themeName!="light"?"":"white"
            }}
            onClick={() =>{
              console.log("---- On Click Running ----");
              if(searchResultLength > 0){
                let tempPaginationObj = {
                  pageIndex : props.pagination.pageIndex +1,
                  pageSize : props.pagination.pageSize
                };
                
                props.setPagination(tempPaginationObj)
              }else{
                console.log("---- No More Pages Running ----");
                setAlertSuccessModal(()=>{
                  const newItem = {...alertSuccessModal};
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.isError = false;
                  newItem.isSuccess = false;
                  newItem.isWarning = true;
                  newItem.description = t("string-literals.no-more-pages");
                  return newItem;
                });
              }
              
            }}
          >
            <Icon
              iconName="ChevronRight"
              className={`pagination-pageCountElement-study-list ${searchResultLength <= 0
                ? "pagination-disabled-study-list"
                : ""}`}
              style={{color: themeName != "light" ?'white':'black'}}
              
            ></Icon>
          </div>
        </div>
        {(props.roles[0] == USERTYPES.FIRMADMIN || props.roles[0] == USERTYPES.RADIOLOGIST || ( props.roles[0] == USERTYPES.SUPERVISOR && getEnv("REACT_APP_VDC_PLATFORM") == "true"))  &&
        
        // <CustomDefaultButton onClick={()=>{props.setShowCount((prev)=>!prev)}} 
        // text={!props.showCount?t("button.hide-pagination"):t("button.show-pagination")}
        //  />
        <div className="studylist-underline-button" onClick={()=>{props.setShowCount((prev)=>!prev)}}>
            {!props.showCount?t("button.hide-pagination"):t("button.show-pagination")}
          </div>
        
        
        // <PrimaryButton 
        //     text={!props.showCount?"Hide Pagination":"Show Pagination"}
        //     onClick={()=>{props.setShowCount((prev)=>!prev)}}
        //     style={{
        //       fontSize: "12px",
        //       fontWeight: "400",
        //       padding: "0px 3px",
        //       height: "30px",
        //       background: themeName =="dark" || themeName =="dark-midnight"?"rgb(107 104 104 / 26%)":"#80808000",
        //       border: themeName =="dark" || themeName =="dark-midnight"?"none":"1px solid black",
        //       color:themeName =="dark" || themeName =="dark-midnight"?"white":"black",
        //       borderRadius: "5px",
        //       marginLeft: "10px",
              
        //     }}
        // />
          }
          
          {!props.showCount && (props.roles[0] == USERTYPES.FIRMADMIN || props.roles[0] == USERTYPES.RADIOLOGIST || props.roles[0] == USERTYPES.SUPERVISOR) && getEnv("REACT_APP_VDC_PLATFORM") == "true" && (<div style={{ "marginLeft": "10px"}}>Displaying {start}-{end} of {currTotalRecordCount}</div>)}

          {/* <BrowserCheck /> */}
      </div>
      
    )
}

export default TablePaginationv2;